// TODO should we reuse scope between translations and feature-flags services?
export var Scope;
(function (Scope) {
    Scope["provider"] = "provider";
    Scope["courier"] = "courier";
    Scope["eater"] = "eater";
    Scope["foodhub"] = "foodhub";
})(Scope || (Scope = {}));
